import React from 'react';
import IF from '@/components/IF';
import {
    WeatherStationCheckboxSelected,
    WeatherStationCloseIcon,
    WeatherStationCheckboxUnselected
} from '@/resource/IconComponentSets';
import './index.less';
import { ISelectedProps } from '../SoilSupplierPropertiesComponent/SoilSupplierPropertiesComponent';

interface IProps {
    selectedDataSource?: ISelectedProps
    onClick?: () => void
    deleteCallback: (id: number) => void
    selected: boolean
    selectedCallback: (id: number, selected: boolean) => void
}

const SoilSupplierComponent = (props: IProps) => {
    const {
        selectedDataSource,
        onClick,
        deleteCallback,
        selectedCallback,
        selected = false
    } = props;


    return (
        <div className='soil-supplier-super-div' title={selectedDataSource.showSelected} onClick={() => onClick && onClick()}>
            <IF show={selected}>
                <button className='check-box-style' onClick={() => selectedCallback && selectedCallback(selectedDataSource.hierarchyId, false)}>
                    <WeatherStationCheckboxSelected />
                </button>
            </IF>
            <IF show={!selected}>
                <button className='check-box-style' onClick={() => selectedCallback && selectedCallback(selectedDataSource.hierarchyId, true)}>
                    <WeatherStationCheckboxUnselected className='unselected-icon' />
                </button>
            </IF>
            <div className='selected-data-source-text-div'>
                <span>{selectedDataSource.showSelected.replace('_', '/')}</span>
                {/* <SoilProfileDropDownIcon /> */}
            </div>
            <button className='close-button-style' onClick={() => deleteCallback(selectedDataSource.hierarchyId)}>
                <WeatherStationCloseIcon className='close-icon' />
            </button>
        </div>
    );
};

export default SoilSupplierComponent;